module.exports = __webpack_public_path__ + "static/media/kk_thumb_even.d6b54282.jpg";